module.exports = __webpack_public_path__ + "static/media/phone-slash.c01f372d.svg";